import React, { useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";
import { GeneratePdfAPI, GetModuleListAPI, GetSSRSReportAPI } from "../../services";
import { DownloadByContent } from "../utils";
import { Link } from "react-router-dom";
import { CloseTicketAPI } from "../../services";
import { Toastify } from '../utils';

const AdditionalButtons = ({module, id, dataEntry}) =>
{
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [showReports, ShowReports] = useState(false);
	const [reports, SetReports] = useState([]);
	const FetchReports = async () =>
	{
		if(!showReports)
		{
			const data = {
				selected_fields: ['id', 'name'],
				offset: 0,
				limit: 500,
				query: '`rahkaran_reports`.`parent_type`="'+module+'"',
				parent_type: module
			};
			const APIResponse = await GetModuleListAPI('Rahkaran_Reports', data);
			if (APIResponse.length)
			{
				SetReports(APIResponse);
				ShowReports(true);
			}
		}
		else
		{
			ShowReports(false);
		}
	}

	const FetchRahkaranReport = async (reportID) =>
	{
		GetSSRSReportAPI(reportID, id).then(response =>
		{
			if(response && response.content)
			{
				DownloadByContent(response.content, response.name);
			}
			ShowReports(false);
		});
	}

	const GeneratePdf = async () =>
	{
		const APIResponse = await GeneratePdfAPI(id, module);
		if (APIResponse && APIResponse.content)
		{
			DownloadByContent(APIResponse.content, APIResponse.name);
		}
	}

	const CloseTicket = async () =>
	{
		// seprate api for closing ticket / this is for cases module only and seprated becaouse of required fields
		const data = {status : 'Closed'};
		const result = await CloseTicketAPI(data, module, id);
		if(result && result.id)
		{
			Toastify(result.message);
			setTimeout(() => {
				window.location.reload();
			}, 1600);
		}
	}

	return <>
		{settings.gateway_enable && settings.gateway_enable === "1" && settings.payOn && settings.payOn.includes(module)? <Link to={`/gateway/${module}/${id}`} className="btn mb-2">{language["PAY"]}</Link>: null}
		{settings.pdf_modules.includes(module) ? <button onClick={GeneratePdf} className='btn btn-secondary mb-2'>{language["PDF"]}</button> : null}
		{module == 'Cases' && dataEntry && dataEntry?.status !== 'Closed' ? <button onClick={CloseTicket} className='btn btn-secondary border-danger text-danger mb-2'>{language["CLOSE_TICKET"]}</button> : null}
		{settings.definitions && Object.keys(settings.definitions.modules).includes('Rahkaran_Reports') && settings.rahkaran_reports && settings.rahkaran_reports.includes(module) ? 
		<>
		<button className='btn btn-secondary mb-2 pe-6' onClick={FetchReports}>{language["RAHKARAN_REPORTS"]} <i className="fa fa-caret-down ms-4"></i></button>
		{showReports ? <>
		<div className="absolute w-full z-10 h-[calc(100vh-300px)] top-0 left-0" onClick={() => ShowReports(false)}></div>
		<ul className="ms-1 absolute top-12 z-20 bg-wrapperBG border border-primaryBorder text-sm rounded max-w-[350px]">
			{reports.map((report, index) => <li key={index} onClick={() => FetchRahkaranReport(report.id)} className="p-4 pe-12 border-b border-primaryBorder hover:text-primary cursor-pointer">{report.name}</li> )}
		</ul>
		</> : null}
		</>
		: null}
	</>
}

export default AdditionalButtons;